export default __webpack_public_path__ + "static/media/Marble-rocks.9f16095d.jpg";